<img [class]="class" [src]="'assets/images/logo/' + image" alt="Vibra-Stop" />
